<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row" style="justify-content: flex-end;">
                                <div class="col">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>

                            <div class="modal-body">
                                <h2 class="title">{{ isNew ? 'New' : 'Edit' }} {{form_type}} </h2>
                                <p class="sub--title">* is a required field</p>
                                <form>
                                    <div class="row row-space">
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Username<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.username"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Username"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Type</label>
                                                <MultiSelect
                                                    v-model="form.type"
                                                    :options="options.type"
                                                    :allow-empty="false"
                                                    :disabled="true"
                                                    placeholder="Choose Type"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <template v-if="isNew">
                                            <div class="col-md-6">
                                                <div class="input-group">
                                                    <label class="label">Password<span style="color: red;">*</span></label>
                                                    <input
                                                        v-model="form.password"
                                                        type="password"
                                                        class="input--style-4"
                                                        placeholder="Type Password"
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="input-group">
                                                    <label class="label">Re-type Password<span style="color: red;">*</span></label>
                                                    <input
                                                        v-model="retype_password"
                                                        type="password"
                                                        class="input--style-4"
                                                        placeholder="Type Retype Password"
                                                    >
                                                </div>
                                            </div>
                                        </template>
                                        <div class="col-md-6" v-if="config.is_company_exist" :class="{'offset-md-3' : isNew}">
                                            <div class="input-group">
                                                <label class="label">Company</label>
                                                <MultiSelect
                                                    v-model="form.company"
                                                    :options="options.oilMaker.map(x => x.code)"
                                                    :custom-label="opt => options.oilMaker.find(x => x.code == opt).title"
                                                    placeholder="Choose Oil Maker"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="!isNew" :class="{'offset-md-3' : !config.is_company_exist}">
                                            <div class="input-group">
                                                <label class="label">Status<span style="color: red;">*</span></label>
                                                <MultiSelect
                                                    v-model="form.status"
                                                    :options="options.status"
                                                    :allow-empty="false"
                                                    placeholder="Choose Status"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row row-space outerBoxPass" v-if="!isNew">
                                      <div class="col innerBoxPass paddingInnerInnerBox whiteBg">
                                        <div class="row" @click="collapsedPass = !collapsedPass">
                                          <div class="col-6 left">
                                            <p class="subPartTitle">Reset Password</p>
                                          </div>
                                          <div class="col-6 right">
                                            <button type="button" class="btn btn-link collapseButton" v-if="collapsedPass">+</button>
                                            <button type="button" class="btn btn-link collapseButton" v-else>-</button>
                                          </div>
                                        </div>
                                        <div class="row" v-if="!collapsedPass">
                                          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="input-group">
                                              <label class="label">Password</label>
                                              <input class="input--style-4" type="password" name="password" v-model="form.password" placeholder="Type Password">
                                            </div>
                                          </div>
                                          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="input-group">
                                              <label class="label">Re-type Password</label>
                                              <input class="input--style-4" type="password" name="retype_password" v-model="retype_password" placeholder="Type Retype Password">
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                        <div class="col mt-5" style="text-align: center">
                                            <button type="button" class="btn btn-outline-danger" style="font-size:140%"
                                                @click="$emit('closeModal')">Cancel</button>
                                            <button type="button" class="btn btn-primary ml-5" style="font-size:150%"
                                                @click="submitForm()">{{ isNew ? 'Create' : 'Edit' }}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import MultiSelect from 'vue-multiselect';

    export default {
        data() {
            let user = this.$store.getters.currentUser

            return {
                dataReady : false,
                mobile: this.isMobile(),
                isNew : true,
                config : {
                    is_company_exist : false,
                },
                options : {
                    type : ['ADMIN'],
                    status : ['ACTIVE', 'INACTIVE'],
                    oilMaker : this.$store.getters.getOilMaker,
                },
                form: {
                    username : '',
                    type : 'ADMIN',
                    password : '',
                    status : true,
                },
                retype_password : '',

                collapsedPass : true
            }
        },
        props : [
            'data',//data used for edit mode
            'is_company_exist',//company exist in this form or not
            'api_new',//api url used for new
            'api_edit',//api url used for edit
            'form_type'
        ],
        components: {
            MultiSelect,
        },
        async mounted() {
            this.config.is_company_exist = this.is_company_exist;

            if (this.data) await this.convertEdit();
        },
        watch: {
            'form.karesidenan' () {
                this.options.city = this.$store.getters.getCityBySingleId(this.form.karesidenan);
                this.form.city = '';
            },
        },
        methods: {
            convertEdit() {
                this.isNew = false;

                this.form.id = this.data.id;
                this.form.username = this.data.username;
                this.form.type = this.data.type;
                this.form.status = this.data.status;

                //Optional for some
                this.form.company = this.data.company;
            },
            notNullObject (obj) {
                let ret = {}
                for (var i in obj) if(obj[i] !== null && obj[i] !== '')ret[i] = obj[i]
                return ret;
            },
            validateForm() {
                let errors = [];

                // Username
                if (!this.form.username) errors.push('<strong>Username</strong> is a required field!');

                // Type
                if (!this.form.type) errors.push('<strong>Type</strong> is a required field!');

                // COMPANY EXIST
                if (this.config.is_company_exist) {
                    // Company
                    if (!this.form.company) errors.push('<strong>Company</strong> is a required field!');   
                }

                // NEW MODE
                if (this.isNew) {
                    // Password
                    if (!this.form.password) errors.push('<strong>Password</strong> is a required field!');
                    // Retype Password
                    else if (!this.retype_password) errors.push('<strong>Retype Password</strong> is a required field!');
                    // Password does not match with retype password
                    else if (this.form.password !== this.retype_password) errors.push('<strong>Password</strong> does not match with <strong>Retype Password</strong>!');
                }

                // EDIT MODE
                else {
                    // Status
                    if (!this.form.status) errors.push('<strong>Status</strong> is a required field!');

                    // Reset Password Not Empty
                    if (this.form.password || this.retype_password) {
                        // Password does not match with retype password
                        if (this.form.password !== this.retype_password) errors.push('<strong>Password</strong> does not match with <strong>Retype Password</strong>!');
                    }
                }

                if (errors.length > 0) {
                    this.$swal.fire({
                        title : "Error!",
                        icon : "error",
                        type : "error",
                        html : errors.join("<br>")
                    })
                    return false;
                } else 
                    return true;
            },
            async submitForm() {
                let vm = this;

                if (await vm.validateForm()) {
                    let method = this.isNew ? 'post' : 'put';
                    let url = this.isNew ? this.api_new : this.api_edit;

                    let form = JSON.parse(JSON.stringify(this.form))

                    //Check if company exist or not, if not, delete it from the form
                    if (!this.config.is_company_exist) delete form.company;

                    //Check if isNew, delete status
                    if (this.isNew) delete form.status;

                    this.$http[method](url, await this.notNullObject(form))
                    .then((resp) => {
                        // alert(`Partshop ${vm.form.name} has been created`);
                        this.$swal.fire({
                            title : "Success!",
                            icon : "success",
                            text : `User ${this.form.username} has been successfully ${this.isNew ? 'created' : 'edited'}`
                        })

                        this.$emit('refreshData');
                        this.$emit('closeModal');
                    })
                    .catch((err) => {
                        console.log(err);
                        if (Array.isArray(err.response.data.data.details)) {
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                html : err.response.data.data.details.map(x=>x.message).join("<br>")
                            })
                        } else {
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : err.response.data.message
                            })
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    /* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
    input {
        outline: none;
        margin: 0;
        border: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        width: 100%;
        font-size: 14px;
        font-family: inherit;
    }

    .input--style-4 {
        line-height: 50px;
        background: #fafafa;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        padding: 0 20px;
        font-size: 16px;
        color: #666;
        -webkit-transition: all 0.4s ease;
        -o-transition: all 0.4s ease;
        -moz-transition: all 0.4s ease;
        transition: all 0.4s ease;
    }

    .input--style-4::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #666;
    }

    .input--style-4:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #666;
        opacity: 1;
    }

    .input--style-4::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #666;
        opacity: 1;
    }

    .input--style-4:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #666;
    }

    .input--style-4:-ms-input-placeholder {
        /* Microsoft Edge */
        color: #666;
    }

    .label {
        font-size: 16px;
        color: #555;
        text-transform: capitalize;
        display: block;
        margin-bottom: 5px;
    }

    .radio-container {
        display: inline-block;
        position: relative;
        padding-left: 30px;
        cursor: pointer;
        font-size: 16px;
        color: #666;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .radio-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .radio-container input:checked~.checkmark {
        background-color: #e5e5e5;
    }

    .radio-container input:checked~.checkmark:after {
        display: block;
    }

    .radio-container .checkmark:after {
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 12px;
        height: 12px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background: #57b846;
    }

    .checkmark {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #e5e5e5;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .input-group {
        position: relative;
        /* margin-bottom: 22px; */
        padding: 20px;
    }

    .input-group-icon {
        position: relative;
    }

    .input-icon {
        position: absolute;
        font-size: 18px;
        color: #999;
        right: 18px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
    }

    /* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
    .title {
        font-size: 40px;
        color: #525252;
        /* margin-bottom: 40px; */
        text-align: center;
    }

    .sub--title {
        color: red;
        margin-bottom: 40px;
        text-align: center;
    }
  
    
    .center{
        text-align: center;
    }
    .left{
        text-align: left;
    }
    .right{
        text-align: right;
    }
    
    .outerBox{
        padding: 0 20px;
    }
    .innerBox{
        border:1px solid #EEEEEE;
        border-radius:5px;
        background-color: white;
        padding:5vw;
        box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15)
    }
    .paddingInnerInnerBox{
        padding:10px 15px;
    }
    .outerBoxPass{
        padding: 20px;
    }
    .innerBoxPass{
        border:1px solid #BDBDBD;
        border-radius:5px;
        box-shadow: 10px 10px 20px #E0E0E0;
    }
    .innerBoxPass>.row:first-child{
        cursor: pointer;
    }
    .paddingInnerInnerBox p{
        margin: 0;
    }
    .subPartTitle{
        font-size: 110%;
        padding: 6px 12px;
        color: #757575;
    }
    .collapsed:hover{
        text-decoration: underline;
    }
    .collapseButton{
        color: black;
    }



    .input--style-4:disabled {
        background: #cfcfcf;
    }

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .innerBox {
        padding: 0.8em 1.5em;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }

    .hoverable:hover {
        cursor: pointer;
    }
</style>